export interface IFocus {
  storeId: number;
  collectionId: number;
  wanted?: string;
  disliked?: string;
  id?: number;
}

export interface IFocusWithCollection extends IFocus {
  collectionId: number;
}

export const META_ACTIONS = {
  REQUESTED: 'meta/requested',
  SUCCEEDED: 'meta/succeeded',
  FAILED: 'meta/failed',
};

export const UPDATE_FOCUS = 'store/UPDATE_FOCUS';
export const UPDATE_FOCUS_SUCCESS = 'store/UPDATE_FOCUS_SUCCESS';

export interface FocusSuccess {
  type: string;
  payload: { focus: IFocusWithCollection };
}

export const updateFocusSuccess = (focus: IFocusWithCollection): FocusSuccess => ({
  type: UPDATE_FOCUS_SUCCESS,
  payload: { focus },
});

export const metaRequested = () => ({
  type: META_ACTIONS.REQUESTED,
});

export const metaSucceeded = (meta: any) => ({
  type: META_ACTIONS.SUCCEEDED,
  payload: { meta },
});

export const metaFailed = (error: any) => ({
  error,
  type: META_ACTIONS.FAILED,
});

export const updateFocus = (focus: IFocus) => ({
  type: UPDATE_FOCUS,
  payload: focus,
});



// WEBPACK FOOTER //
// ./src/store/meta/actions.ts